import MockAgentTransport from "./MockAgentTransport";
import SseAgentTransport from "./SseAgentTransport";

/**
 * Transport contract every implementation must satisfy:
 *   connect(conversationId, onEvent) -> unsubscribe()
 *   send(clientEvent) -> void   (fire-and-forget; replies arrive via onEvent)
 *   interrupt() -> void         (fire-and-forget; stops the in-flight turn)
 *   fetchTablePage?(tableId, page, pageSize) -> Promise (live only)
 *
 * LIVE is the default (real Gemini + MCP tools via the salesgear-mcp
 * orchestrator; API key in localStorage sg_copilot_api_key). The scripted
 * demo mock survives only behind an explicit sg_copilot_mock=1 flag.
 */
const isMockForced = () => {
  try {
    return localStorage.getItem("sg_copilot_mock") === "1";
  } catch (e) {
    return false;
  }
};

export const createAgentTransport = () =>
  isMockForced() ? new MockAgentTransport() : new SseAgentTransport();

export default createAgentTransport;
